import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "stylesheets/components/material-icons/material-icons.scss";

const MaterialIcon = React.forwardRef(({ name, className, ...props }, ref) => (
  <span
    className={classNames("material-icons", className)}
    ref={ref}
    {...props}
  >
    {name}
  </span>
));

MaterialIcon.propTypes = {
  /**
   * The Material UI icon name
   */
  name: PropTypes.string.isRequired,
  /**
   * Any additional classes to add to icon element.
   */
  className: PropTypes.string
};

MaterialIcon.defaultProps = {
  className: ""
};

export default MaterialIcon;
